import { Badge } from '@/components/ui/Badge';

/** Marks a person who is on the user's team, beside their name */
export const TeamLabel = () => (
  <Badge
    variant="secondary"
    className="shrink-0 font-normal text-foreground-muted"
  >
    Team
  </Badge>
);
